import { all, call, put, takeLeading } from 'redux-saga/effects';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import {
  TEMPLATE_EDIT__PDF_LOAD_FAILURE,
  TEMPLATE_EDIT__PDF_LOAD_REQUEST,
  TEMPLATE_FIELD_DELETE,
} from '@app/store/actionTypes';
import { removeNodeFromDocumentRenderTree } from '@app/store/document/renderTree/actions';
import { modalOpen } from '@app/store/modal/actions';
import {
  templateEditLoadPdfFailure,
  templateEditLoadPdfRequest,
  templateEditLoadPdfSuccess,
  templateFieldDelete,
} from '@app/store/template/actions';
import { getFileFromURL } from '@app/store/transport-layer/files';

export function* removeField({ payload: { id } }: ReturnType<typeof templateFieldDelete>) {
  yield put(removeNodeFromDocumentRenderTree(id));
}

export function* templateEditFetchPDF({ payload }: ReturnType<typeof templateEditLoadPdfRequest>) {
  try {
    const { data: pdfArrayBuffer } = yield call(getFileFromURL, payload.url);
    yield put(templateEditLoadPdfSuccess({ pdfArrayBuffer }));
  } catch (error) {
    yield put(templateEditLoadPdfFailure({ error }));
  }
}

export function* notifyFailPdfDownload({
  payload: { error },
}: ReturnType<typeof templateEditLoadPdfFailure>) {
  yield put(
    modalOpen('CONFIRM', {
      title: '템플릿 추가하기 실패',
      content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
    })
  );
}

export default function* templateSagas() {
  yield all([
    takeLeading(TEMPLATE_FIELD_DELETE, removeField),
    takeLeading(TEMPLATE_EDIT__PDF_LOAD_REQUEST, templateEditFetchPDF),
    takeLeading(TEMPLATE_EDIT__PDF_LOAD_FAILURE, notifyFailPdfDownload),
  ]);
}
